// AUTO-GENERATED by scripts/generate-release.mjs — DO NOT EDIT.
// Regenerated at every build. Frontend and edge functions import this so
// Sentry events share the same release tag.

export const RELEASE = "techvinex@f4e2688fa3-dirty";
export const ENVIRONMENT = "production";
